<template>
  <div>
    <!-- error modal -->
    <CModal :show="cookies" removeBackdrop @close="cookies=false" fullHeight position="top">
      <CModalBody class="modal-body-error">
        <CRow center class="align-items-center">
          <mdb-icon icon="exclamation-circle" class="icono-error mr-2" />
          <p class="pr-2 mb-0">{{messageError}}</p>
          <!-- <mdb-btn outline="danger" @click="closedialog()">Ok</mdb-btn> -->

        </CRow>
      </CModalBody>
      <CModal-footer center slot="footer">
        <mdb-btn color="danger" @click="closedialog()">Ok</mdb-btn>
      </CModal-footer>
    </CModal>
    <!-- error modal -->

    <!-- trigger modal button -->
    <!-- cart modal -->
    <CModal :show="push" @close="push = false" class="text-center" info>
      <CModal-header center :close="false" slot="header">
        <p class="heading">Anuncio creado con exito</p>
      </CModal-header>
      <CModal-body class="modal-body">
        <mdb-icon icon="bell" size="4x" class="animated rotateIn mb-4" />
        <p>Has creado el anuncio paso a paso con exito, puedes terminar la tarea ahora.</p>
      </CModal-body>
      <CModal-footer center slot="footer">
        <mdb-btn color="primary" @click="push = false">Terminar</mdb-btn>
      </CModal-footer>
    </CModal>

    <template>
      <!-- poll modal -->
      <CModal :show="modalCreate" @close="modalCreate = false" fullHeight info removeBackdrop>
        <CModal-header center :close="false" slot="header">
          <p class="heading lead">{{ modalName}}</p>
        </CModal-header>
        <CModalBody class="modal-body">
          <modal-create-partner :onClick="closeModalCreate" v-if="modalName == 'Crear Partner' "></modal-create-partner>

          <modal-edit-partner :partner="partnerSelected" :onClick="closeModalCreate"
            v-else-if="modalName == 'Editar Partner' "></modal-edit-partner>

          <modal-create-business-account :onClick="closeModalCreate" v-else-if="modalName == 'Crear cuenta Business' ">
          </modal-create-business-account>

          <modal-edit-business-account :account="accountSelected" :onClick="closeModalCreate"
            v-else-if="modalName == 'Editar cuenta Business' "></modal-edit-business-account>

          <modal-create-strategy-action :onClick="closeModalCreate"
            v-else-if="modalName == 'Crear Accion Estrategica' "></modal-create-strategy-action>

          <!--<modal-edit-strategy-action
              :account="accountSelected"
              :onClick="closeModalCreate"
              v-else-if="modalName == 'Editar Accion Estrategica' "
          ></modal-edit-stategy-action>-->

          <modal-create-rule :onClick="closeModalCreate" v-else-if="modalName == 'Crear Rol' "></modal-create-rule>
        </CModalBody>
        <CModal-footer center name="abc" slot="footer">
          <mdb-btn outline="danger" @click="modalCreate = false">Cancelar</mdb-btn>
        </CModal-footer>
      </CModal>
    </template>

    <CRow>
      <CCol lg="8" v-if="isLoading">
        <CRow>
          <div class="offset-5 pt-5">
            <semipolar-spinner :animation-duration="2000" :size="100" color="#63c2de" class="text-center">
            </semipolar-spinner>
          </div>
        </CRow>
      </CCol>
      <CCol lg="8" v-else>
        <form-wizard @on-complete="onComplete" shape="circle" color="#20a0ff" error-color="#ff4949"
          title="Nueva campaña" subtitle="Paso a paso">
          <!--<tab-content title="Datos básicos" icon="fas fa-tasks" :before-change="validateFirstStep"  >-->
          <tab-content title="Datos básicos" icon="fas fa-tasks">
            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Partner
                    <i class="fas fa-plus-circle icono-crear mr-1" @click="modalCreateF('Crear Partner')"></i>
                    <i class="fas fa-edit icono-crear mr-4" @click="modalCreateF('Editar Partner')"
                      v-if="partnerSelected.hasOwnProperty('name')"></i>
                  </label>
                  <multiselect v-model="partnerSelected" tag-placeholder="Add this as new Partner"
                    placeholder="Seleccione un Partner" label="value" track-by="id" :options="partners"
                    :multiple="false" :taggable="true"></multiselect>
                  <!-- @input="getQuizesbyPartner" -->
                  <!-- @select="getPagePromotion" -->
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">País</label>
                  <multiselect v-model="selectedCountry" placeholder="Seleccione el País" label="name" track-by="id"
                    :options="countries" :multiple="false" :taggable="true" @input="getzonelist"></multiselect>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Localizacion</label>
                  <treeselect v-if="!isLoading" :multiple="true" :options="locations"
                    :load-options="getlocationbyPartner" v-model="localizacionElejida" />
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Ratio
                  </label>
                  <input v-model="ratioElejido" type="number" class="form-control" placeholder="Ratio" />
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Tipo de campaña</label>
                  <multiselect v-model="campañaElejida" deselect-label placeholder="Seleccione el tipo de campaña"
                    track-by="id" label="name" :options="tipoCampaña" :allow-empty="false"></multiselect>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Objetivo</label>
                  <multiselect v-model="lastLocationSelected" deselect-label placeholder="Seleccione el tipo de campaña"
                    track-by="id" label="name" :options="lastLocation" :allow-empty="false"></multiselect>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <!-- <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Promoción
                    <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalCreateF('Crear Promoción')"
                    ></i>
                  </label>
                  <multiselect
                    v-model="promotionSelected"
                    tag-placeholder="Añadir nueva oferta"
                    placeholder="Seleccione la Oferta"
                    label="name"
                    track-by="id"
                    :options="promotions"
                    :multiple="false"
                    :taggable="true"
                  ></multiselect>
                </div>
              </CCol>-->

              <!-- <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Cuenta
                    <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalCreateF('Crear cuenta Business')"
                    ></i>
                    <i
                      class="fas fa-edit icono-crear mr-2"
                      @click="modalCreateF('Editar cuenta Business')"
                      v-if="accountSelected.hasOwnProperty('name')"
                    ></i>
                  </label>
                  <multiselect
                    v-model="accountSelected"
                    placeholder="Seleccione la cuenta"
                    label="name"
                    track-by="id"
                    :options="accounts"
                    @select="getPixels"
                    :multiple="false"
                    :taggable="false"
                  ></multiselect>
                </div>
              </CCol> -->
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Survey
                    <!--  -->
                  </label>
                  <multiselect v-model="quizSelected" placeholder="Seleccione la cuenta" label="qul_name" track-by="id"
                    :options="quizes" :multiple="false" :taggable="false"></multiselect>
                  <!-- @select="getPixels" -->
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Nombre de campaña</label>
                  <input type="text" class="form-control" placeholder="Nombre de campaña" v-model="campaignName" />
                </div>
              </CCol>

            </CRow>

            <CRow>

              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Pagina de Facebook</label>
                  <!--Páginas-->
                  <multiselect v-model="pageSelected" tag-placeholder="Agrega nueva página"
                    placeholder="Seleccione la página" label="name" track-by="id" :options="pages" :multiple="false">
                  </multiselect>
                </div>
              </CCol>
              <!-- 
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Status</label>
                  <multiselect
                    v-model="statusSelected"
                    placeholder="Seleccione el estatus"
                    label="name"
                    track-by="value"
                    :options="status"
                    :multiple="false"
                    :taggable="false"
                  ></multiselect>
                </div>
              </CCol> -->
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Cuenta de Instagram </label> <!-- cuenta de usuario -->
                  <multiselect v-model="userAccount" tag-placeholder="Agrega nueva página"
                    placeholder="Seleccione la página" label="name" track-by="id" :options="userAccounts"
                    :multiple="false"></multiselect>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Pixel
                    <button type="button" class="boton-pregunta" data-toggle="tooltip" data-placement="top"
                      title="Añade o selecciona el píxel de Facebook a tu sitio web para realizar un seguimiento de las conversiones de anuncios, mejorar la segmentación de la audiencia y maximizar el retorno del gasto publicitario. Consulta las acciones que las personas realizan después de ver tus anuncios y crea audiencias para llegar a personas similares a tus mejores clientes">
                      <mdb-icon class="icono-crear" icon="question-circle" />
                    </button>

                  </label>
                  <multiselect v-model="pixelSelected" placeholder="Seleccione el pixel" label="label" track-by="id"
                    :options="pixels" :multiple="false"></multiselect>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Presupuesto
                  </label>
                  <input type="number" class="form-control" placeholder="Presupuesto" v-model="lifetime_budget" />
                </div>
              </CCol>


            </CRow>

            <CRow>
            </CRow>

            <CRow>
              <CCol lg="12">
                <div class="form-group">
                  <label class="typo__label">
                    Link visible
                    <button type="button" class="boton-pregunta" data-toggle="tooltip" data-placement="top"
                      title="Si añades la URL de tu sitio web, las personas que hagan clic en tu anuncio o lo toquen irán a tu sitio web. Si no lo haces, irán a tu página de Facebook o tu cuenta de Instagram.">
                      <mdb-icon class="icono-crear" icon="question-circle" />
                    </button>

                  </label>
                  <input type="text" class="form-control" placeholder="www.anuncio.com" v-model="adVisibleLink" />
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label>Fecha inicio</label>
                  <datetime type="datetime" input-id="fecha-input" format="yyyy-MM-dd HH:mm:ss" v-model="start_date">
                  </datetime>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label>Fecha fin</label>
                  <datetime type="datetime" input-id="fechafin-input" format="yyyy-MM-dd HH:mm:ss" v-model="end_date">
                  </datetime>
                </div>
              </CCol>
            </CRow>

          </tab-content>

          <!-- <tab-content title="Datos de facturación del Ad" icon="fas fa-money-check">
            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Estrategia</label>
                  <multiselect
                    v-model="bidStrategySelected"
                    placeholder="Seleccione una estrategia de oferta"
                    label="name"
                    track-by="value"
                    :options="bidStrategys"
                    :multiple="false"
                  ></multiselect>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Facturación</label>
                  <multiselect
                    v-model="billingEventSelected"
                    placeholder="Facturación de evento"
                    label="name"
                    track-by="code"
                    :options="billingEvents"
                    :multiple="false"
                    :taggable="false"
                  ></multiselect>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Optimización de Logros</label>
                  <multiselect
                    v-model="optimizationGoalSelected"
                    placeholder="Seleccione un logro"
                    label="name"
                    track-by="code"
                    :options="optimizationGoals"
                    :multiple="false"
                  ></multiselect>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Ritmo</label>
                  <multiselect
                    v-model="pacingTypeSelected"
                    placeholder="Tipo de ritmo"
                    label="name"
                    track-by="value"
                    :options="pacingTypes"
                    :multiple="false"
                    :taggable="false"
                  ></multiselect>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Presupuesto Diario
                    <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                      <span slot="tip">
                        Facebook intentará gastar todo el presupuesto y obtener el mayor número de clicks
                        en el enlace aplicando la estrategia de puja de menor coste.
                      </span>
                      <mdb-btn slot="reference" class="boton-pregunta">
                        <mdb-icon class="icono-crear" icon="question-circle" />
                      </mdb-btn>
                    </mdb-tooltip>
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    class="form-control"
                    placeholder="Presupuesto diario"
                    v-model="dailyBudget"
                    autocomplete="false"
                  />
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Coste por Click
                    <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                      <span slot="tip">
                        El presupuesto del conjunto de anuncios es el importe
                        diario o total que quieres gastar en este conjunto de anuncios.
                      </span>
                      <mdb-btn slot="reference" class="boton-pregunta">
                        <mdb-icon class="icono-crear" icon="question-circle" />
                      </mdb-btn>
                    </mdb-tooltip>
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    class="form-control"
                    placeholder="Coste por click"
                    v-model="bidamounts"
                    autocomplete="false"
                  />
                </div>
              </CCol>
            </CRow>
          </tab-content>
 -->
          <!-- <tab-content title="Contenido del Ad" icon="fas fa-ad" :before-change="validateThirdStep"> -->
          <tab-content title="Contenido del Ad" icon="fas fa-ad" :before-change="validateThirdStep">
            <div v-for="(ad,index) in ads" :key="index">
              <CRow>
                <CCol lg="12">
                  <div class="form-group">
                    <label class="typo__label">Título AD</label>
                    <input type="text" class="form-control" placeholder="Titulo AD" v-on:input="adChange(index)"
                      v-model="ad.titleAd" />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div class="form-group">
                    <label class="typo__label">Contenido AD</label>
                    <textarea class="form-control" placeholder="Contenido AD" rows="3" v-on:input="adChange(index)"
                      v-model="ad.contentAd"></textarea>
                  </div>
                </CCol>
                <CCol lg="6">
                  <div class="form-group">
                    <label class="typo__label">Descripción AD</label>
                    <textarea class="form-control" placeholder="Descripción AD" rows="3" v-on:input="adChange(index)"
                      v-model="ad.descriptionAd"></textarea>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <!-- <CCol lg="6">
                  <div class="form-group">
                    <label class="typo__label">Tipo de AD</label>
                    <multiselect
                      v-model="ad.typeAdSelected"
                      :options="typeAds"
                      placeholder="tipo"
                      v-on:input="adChange(index)"
                      label="name"
                      track-by="value"
                    ></multiselect>
                  </div>
                </CCol> -->
                <CCol lg="6">
                  <div class="form-group">
                    <label class="typo__label">Call to action</label>
                    <multiselect v-model="ad.CallToActionSelected" :options="CallToActions" v-on:input="adChange(index)"
                      placeholder="Call to action" label="name" track-by="id"></multiselect>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <!--<CCol lg="12">
                <div class="form-group">
                  <label for="exampleFormControlFile1">Suba la imagen destacada</label>
                  <input
                    type="file"
                    class="form-control-file"
                    multiple
                    accept=".png, .jpg, .jpeg"
                    :id="'files-'+index"
                    @change="previewFiles(index)"
                  />
                </div>
                </CCol>-->

                <CCol lg="12">
                  <div class="form-group">
                    <label for="exampleFormControlFile1">Suba la imagen destacada</label>
                    <input type="file" class="form-control-file" multiple
                      accept=".png, .jpg, .jpeg, video/mp4, video/x-m4v, video/*" :id="'files-'+index"
                      @change="previewFiles(index)" />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <div class="col-8 offset-2">
                  <mdb-btn color="danger" @click="removeAd(index)">Eliminar</mdb-btn>
                  <mdb-btn color="primary" @click="showAd(index)">Mostrar</mdb-btn>
                  <mdb-btn v-if="index + 1 === ads.length" @click="addAd()" color="success">Agregar</mdb-btn>
                </div>
              </CRow>
            </div>
          </tab-content>

          <tab-content title="focalización" icon="fas fa-globe">
            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Selecciona Estrategia de Segmentación
                    <!-- <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                      <span
                        slot="tip"
                      >Elige "Ambos" a menos que quieras que tus anuncios se muestren solo a hombres o solo a mujeres.</span>
                      <mdb-btn slot="reference" class="boton-pregunta">
                        <mdb-icon class="icono-crear" icon="question-circle" />
                      </mdb-btn>
                    </mdb-tooltip>-->
                  </label>
                  <multiselect v-model="segmentationStrategiesSelected" deselect-label
                    placeholder="Seleccione el genero" track-by="id" label="name" @input="getAllData"
                    :options="segmentationStrategies" :searchable="false" :allow-empty="false"></multiselect>
                  <!-- @input="getAllData" -->
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Genero
                    <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                      <span slot="tip">Elige "Ambos" a menos que quieras que tus anuncios se muestren solo a hombres o
                        solo a mujeres.</span>
                      <mdb-btn slot="reference" class="boton-pregunta">
                        <mdb-icon class="icono-crear" icon="question-circle" />
                      </mdb-btn>
                    </mdb-tooltip>
                  </label>
                  <multiselect v-model="genderSelected" deselect-label placeholder="Seleccione el genero" track-by="id"
                    label="name" :options="genders" :searchable="false" :allow-empty="false"></multiselect>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">
                    Edad mínima
                    <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                      <span slot="tip">Selecciona la edad mínima y máxima de las personas para las que será relevante tu
                        anuncio</span>
                      <mdb-btn slot="reference" class="boton-pregunta">
                        <mdb-icon class="icono-crear" icon="question-circle" />
                      </mdb-btn>
                    </mdb-tooltip>
                  </label>
                  <input type="number" class="form-control" placeholder="edad min" v-model="minAge" min="13" />
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Edad máxima</label>
                  <input type="number" class="form-control" placeholder="edad max" v-model="maxAge" :min="minAge" />
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="6">
                <div class="form-group">
                  <!-- <label class="typo__label"></label> -->
                  <!-- <multiselect
                    v-model="conectionTypeSelected"
                    placeholder="tipo de conexión"
                    label="name"
                    track-by="id"
                    :options="conectionTypes"
                    :multiple="false"
                  ></multiselect> -->
                  <div class="form-group pl-4 pt-4">
                    <input type="checkbox" class="form-check-input" v-model="recommended_locations" />
                    <label class="form-checl-lable">Ubicaciones recomendadas</label>
                  </div>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Tipo de conexión</label>
                  <multiselect v-model="conectionTypeSelected" placeholder="tipo de conexión" label="name" track-by="id"
                    :options="conectionTypes" :multiple="false"></multiselect>
                </div>
              </CCol>
            </CRow>
            <CRow v-if="!recommended_locations">
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">SO de dispositivos</label>
                  <multiselect v-model="deviceOsSelected" placeholder="SO de dispositivos" label="name" track-by="id"
                    :options="devicesOs" :multiple="true"></multiselect>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Tipo de dispositivos</label>
                  <multiselect v-model="deviceTypeSelected" placeholder="Tipo de dispositivos" label="name"
                    track-by="id" :options="deviceTypes" :multiple="true"></multiselect>
                </div>
              </CCol>
            </CRow>

            <CRow v-if="!recommended_locations">
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Plataformas para el annuncio</label>
                  <multiselect v-model="publisher_platforms_ids" placeholder="Plataformas para el annuncios"
                    label="name" track-by="id" :options="publisherplatformsids" :multiple="true"></multiselect>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Posición</label>
                  <multiselect v-model="position_ids" placeholder="Posición" label="name" track-by="id"
                    :options="positionids" :multiple="true"></multiselect>
                </div>
              </CCol>
            </CRow>
            <!--<CRow>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Comportamientos a incluir</label>
                  <multiselect
                    v-model="behaviorsIncludeSelected"
                    :options="behaviors"
                    @select="filterBehaviorsIncludeDelete"
                    @remove="filterBehaviorsIncludeAdd"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecciona comportamientos"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  >
                  </multiselect>
                </div>
              </CCol>
              <CCol lg="6">
                <div class="form-group">
                  <label class="typo__label">Intereses a incluir</label>
                  <multiselect
                    v-model="interestsIncludeSelected"
                    :options="interests"
                    @select="filterInterestsIncludeDelete"
                    @remove="filterInterestsIncludeAdd"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    @search-change="interestsChange"
                    placeholder="Selecciona intereses"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  >
                    
                  </multiselect>
                </div>
              </CCol>
            </CRow>-->

            <!-- <CRow>
              <CCol lg="12">
                <div class="form-group">
                  <label class="typo__label">zona demografica a incluir</label>
                  <treeselect
                    v-if="!isLoading"
                    v-model="demographicIncludeSelected"
                    :load-options="loadOptions"
                    :multiple="true"
                    :options="countriesIncludes"
                  />
                </div>
              </CCol>
            </CRow> -->

            <CRow>
              <CCol lg="12">
                <div class="form-group">
                  <label class="typo__label">zona demografica a Excluir</label>
                  <treeselect v-if="!isLoading" v-model="demographicExcludeSelected" :load-options="loadOptions"
                    :multiple="true" label="name" :options="countriesIncludes" />
                </div>
              </CCol>
            </CRow>
            <!-- <CRow>
              <CCol lg="6 pt-5">
                <div class="form-group">
                  <input
                    type="checkbox"
                    class="form-control checkbox-2"
                    v-model="split_by"
                    name="checkbox-2"
                  />
                  Separar por provincias
                </div>
              </CCol>
            </CRow>-->

            <!-- <CRow>
              <CCol lg="12">
                <div class="form-group">
                  <label class="typo__label">Audiencias personalizadas a incluir</label>
                  <multiselect
                    v-model="audienciasInclude"
                    :options="audiencias"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecciona intereses"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  ></multiselect>
                </div>
              </CCol>

              <CCol lg="12">
                <div class="form-group">
                  <label class="typo__label">Audiencias personalizadas a excluir</label>
                  <multiselect
                    v-model="audienciasExclude"
                    :options="audiencias"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecciona intereses"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  ></multiselect>
                </div>
              </CCol>
            </CRow>-->
          </tab-content>

          <button class="btn btn-primary" slot="prev">Volver</button>
          <button class="btn btn-primary" slot="next">Siguiente</button>
          <button class="btn btn-primary" slot="finish" v-on:click="partnerLocationChange">Crear</button>
        </form-wizard>
      </CCol>

      <!--PREVIEW-->
      <CCol lg="4" class="contenedor-preview p-2 mb-4">
        <div class="container preview">
          <CRow class="pl-3 pt-3 pb-1">
            <CCol lg="2">
              <div class="bg-dark imagen-perfil"></div>
            </CCol>
            <CCol lg="10">
              <CRow>
                <CCol lg="10 titulo-empresa">
                  <h1>Empresa</h1>
                  <span class="sponsor">
                    <a href="#">{{(typeAdSelected.hasOwnProperty("name"))?(typeAdSelected.name):("Título Ad")}}</a>-
                    <i class="fas fa-globe-americas"></i>
                  </span>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <CRow class="pl-3 pr-3">
            <p style="font-size: 13px">
              {{(contentAd.length)?(contentAd):("Lorem ipsum dolor sit amet consectetur adipisicing elit. pariatur nesciunt doloremque vel odi"
              + "numquam beatae distinctio")}}
            </p>
          </CRow>
          <CRow class="pl-3 pr-3">
            <CCol lg="12" class="bg-dark imagen-destacada">
              <carousel v-if="files.length > 0" :perPageCustom="[[480, 1], [768, 1]]" :navigationEnabled="true"
                :paginationEnabled="false" class="contener-completo">
                <slide v-for="(item,index) in files" :key="index" class="contener-completo">
                  <div v-if="item.type == 'imagen'" class="contener-completo">
                    <img :src="item.url" alt class="contener-completo" />
                  </div>
                  <div v-else class="contener-completo">
                    <video :src="item.url" class="video-component contener-completo" controls></video>
                  </div>
                </slide>
              </carousel>
              <div id="preview-img">
                <img v-if="url" :src="url" height="246" class="imagen" />
              </div>
            </CCol>
            <CCol lg="12" class="descripcion-contenedor">
              <h3 class="addTitle">{{(titleAd.length)?(titleAd):("Título Ad")}}</h3>
              <p>
                {{(descriptionAd.length)?(descriptionAd):("Lorem ipsum dolor sit amet consectetur adipisicing elit. pariatur nesciunt doloremque vel odi"
                + "numquam beatae distinctio nam laboriosam eum laborum dignissimos dolores, sunt excepturi.")}}
              </p>
              <CRow>
                <CCol lg="4">
                  <span class="link-anuncio">{{(adVisibleLink.length)?(adVisibleLink):("www.anuncio.com")}}</span>
                </CCol>
                <div class="offset-5 col-3">
                  <button type="button"
                    class="call-to-action">{{(CallToActionSelected.hasOwnProperty("name"))?(CallToActionSelected.name):("Action")}}</button>
                </div>
              </CRow>
            </CCol>
          </CRow>
          <CRow class="p-3">
            <CCol lg="12">
              <ul class="interaccion">
                <li>200 Likes</li>
                <li>25 Comments</li>
                <li>109 Shares</li>
              </ul>
            </CCol>
          </CRow>
        </div>
      </CCol>
      <!--PREVIEW-->
    </CRow>
  </div>
</template>

<script>
  import store from "../../store";
  import Multiselect from "vue-multiselect";
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import {
    LOAD_CHILDREN_OPTIONS
  } from "@riophae/vue-treeselect";
  import Treeselect from "@riophae/vue-treeselect";
  import "@riophae/vue-treeselect/dist/vue-treeselect.css";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import ModalCreatePartner from "../notifications/ModalCreatePartner";
  import ModalEditPartner from "../notifications/ModalEditPartner";
  import ModalCreateOffert from "../notifications/ModalCreateOffert";
  import ModalEditOffert from "../notifications/ModalEditOffert";
  import ModalCreateBusinessAccount from "../notifications/ModalCreateBusinessAccount";
  import ModalEditBusinessAccount from "../notifications/ModalEditBusinessAccount";
  import ModalCreateRule from "../notifications/ModalCreateRule";
  import ModalCreateStrategyAction from "../notifications/ModalCreateStrategyAction";
  import {
    Datetime
  } from "vue-datetime";
  import {
    Carousel,
    Slide
  } from "vue-carousel";

  //import ModalEditStrategyAction from "../notifications/ModalEditStrategyAction";
  import {
    SemipolarSpinner
  } from "epic-spinners";
  import {
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbTooltip
  } from "mdbvue";

  const simulateAsyncOperation = fn => {
    setTimeout(fn, 2000);
  };

  export default {
    name: "StepByStep",
    components: {
      Carousel,
      Slide,
      Multiselect,
      datetime: Datetime,
      FormWizard,
      TabContent,
      mdbModal,
      mdbModalBody,
      mdbModalHeader,
      mdbModalFooter,
      mdbRow,
      mdbBtn,
      mdbIcon,
      mdbTextarea,
      mdbInput,
      mdbContainer,
      ModalCreatePartner,
      ModalEditPartner,
      ModalEditBusinessAccount,
      ModalCreateOffert,
      ModalEditOffert,
      SemipolarSpinner,
      ModalCreateBusinessAccount,
      ModalCreateRule,
      ModalCreateStrategyAction,
      mdbTooltip,
      Treeselect
    },
    data: () => {
      return {
        lastLocation: [{name: "People living in or recently in this location",
            label: "People living in or recently in this location",
            id: 1
          },
          {
            name: "people living in this location",
            label:"people living in this location",
            id: 2
          },{
            name: "people recently in this location",
            label:"people recently in this location",
            id: 3
          },{
            name: "people traveling in this location",
            label:"people traveling in this location",
            id: 4
          }],
        lastLocationSelected: [],
        data_carrousel: [],
        partnerSelected: {},
        quizSelected: {},
        quizes: [],
        selectedCountry: {},
        promotionSelected: {},
        accountSelected: {},
        pageSelected: {},
        statusSelected: {},
        ruleSelected: {},
        adVisibleLink: "",
        billingEventSelected: {},
        campaignName: "",
        allow_restart: true,
        campaignObjetiveSelected: {},
        pixelSelected: {},
        start_date: "",
        end_date: "",

        bidStrategySelected: {}, //second tab
        billingEventSelected: {},
        strategyActionSelected: {},
        optimizationGoalSelected: {},
        pacingTypeSelected: {},
        bidamounts: "",
        dailyBudget: "",

        ads: [],
        files: [],
        titleAd: "", //third tab
        contentAd: "",
        descriptionAd: "",
        typeAdSelected: {},
        CallToActionSelected: {},
        url: "",
        blockRemoval: true,
        genderSelected: {}, //4th tab
        segmentationStrategiesSelected: {}, //4th tab
        minAge: 13,
        maxAge: 13,
        deviceOsSelected: [],
        deviceTypeSelected: [],
        conectionTypeSelected: {},
        positionids: [],
        recommended_locations: false,
        publisherplatformsids: [],
        position_ids: [],
        publisher_platforms_ids: [],
        behaviorsIncludeSelected: [],
        interestsIncludeSelected: [],
        demographicIncludeSelected: [],
        behaviorsExcludeSelected: [],
        interestsExcludeSelected: [],
        demographicExcludeSelected: [],
        cookies: false,
        push: false,
        modalName: "",
        modalCreate: false,
        split_by: false,
        messageError: "",
        partners: [],
        countries: [],
        localidades: [],
        locations: [],
        tipoCampaña: [{
            name: "Normal",
            label: "Normal",
            id: 1
          },
          {
            name: "Store Visits",
            label: "Store Visits",
            id: 2
          }
        ],
        countriesIncludes: [{
          name: "Spain",
          id: 68,
          label: "Spain",
          code: "ES",
          children: null
        }],
        countriesExclude: [],
        offerts: [],
        promotions: [],
        accounts: [],
        pages: [],
        status: [{
            name: "Activa",
            value: "ACTIVE"
          },
          {
            name: "Pausada",
            value: "PAUSED"
          },
          {
            name: "Eliminada",
            value: "DELETED"
          },
          {
            name: "Archivada",
            id: "ARCHIVED"
          }
        ],
        rules: [],
        campaignObjetives: [],
        pixels: [],
        bidStrategys: [
          //secon tab
          {
            name: "Menor costo sin límite",
            value: "LOWEST_COST_WITHOUT_CAP"
          },
          {
            name: "Menor costo con límite",
            value: "LOWEST_COST_WITH_BID_CAP"
          },
          {
            name: "Costo por objetivo",
            value: "TARGET_COST"
          }
        ],
        billingEvents: [],
        strategyActions: [],
        optimizationGoals: [],
        pacingTypes: [{
            name: "Standard",
            value: "standard"
          },
          {
            name: "Day parting",
            value: "day_parting"
          },
          {
            name: "No pacing",
            value: "no_pacing"
          },
          {
            name: "Disabled",
            value: "disabled"
          }
        ],
        typeAds: [
          //{ name: "App", value: "APPLICATION" },
          {
            name: "Instagram",
            value: "DOMAIN"
          },
          {
            name: "Imagén",
            value: "IMAGE"
          },
          {
            name: "Vídeo",
            value: "VIDEO"
          },
          {
            name: "Página",
            value: "PAGE"
          }
        ],
        CallToActions: [{
            name: "Leer más",
            value: "LEARN_MORE"
          },
          {
            name: "Descargar",
            value: "DOWNLOAD"
          },
          {
            name: "Contactanos",
            value: "CONTACT_US"
          },
          {
            name: "Aplicar ahora",
            value: "APPLY_NOW"
          },
          {
            name: "Reservar ahora",
            value: "BOOK_NOW"
          },
          {
            name: "Enviar mensaje",
            value: "SEND_MESSAGE"
          },
          {
            name: "Descargar en movil",
            value: "MOBILE_DOWNLOAD"
          },
          {
            name: "Obtener oferta",
            value: "GET_OFFER"
          },
          {
            name: "Obtener horarios",
            value: "GET_SHOWTIMES"
          }
        ],
        genders: [
          //4th tab
          {
            name: "Hombre",
            id: "1"
          },
          {
            name: "Mujer",
            id: "2"
          },
          {
            name: "Ambos",
            id: "3"
          }
        ],
        segmentationStrategies: [],
        devicesOs: [{
            name: "IOS",
            id: 1
          },
          {
            name: "Android",
            id: 2
          },
          {
            name: "Window phone",
            id: 3
          },
          {
            name: "Todos",
            id: 4
          }
        ],
        deviceTypes: [{
            name: "Movil",
            id: 1
          },
          {
            name: "Escritorio",
            id: 2
          },
          {
            name: "Todos",
            id: 3
          }
        ],
        conectionTypes: [{
            name: "Wi-fi",
            id: 1
          },
          {
            name: "3G/4G",
            id: 2
          },
          {
            name: "Todos",
            id: 3
          }
        ],
        behaviors: [],
        behaviorsExcludes: [{
            name: "comportamiento 1",
            id: 1
          },
          {
            name: "comportamiento 2",
            id: 2
          },
          {
            name: "comportamiento 3",
            id: 3
          },
          {
            name: "comportamiento 4",
            id: 4
          },
          {
            name: "comportamiento 5",
            id: 5
          },
          {
            name: "comportamiento 6",
            id: 6
          }
        ],
        behaviorsIncludes: [{
            name: "comportamiento 1",
            id: 1
          },
          {
            name: "comportamiento 2",
            id: 2
          },
          {
            name: "comportamiento 3",
            id: 3
          },
          {
            name: "comportamiento 4",
            id: 4
          },
          {
            name: "comportamiento 5",
            id: 5
          },
          {
            name: "comportamiento 6",
            id: 6
          }
        ],
        interests: [],
        interestsIncludes: [{
            name: "musica",
            id: 1
          },
          {
            name: "futbol",
            id: 2
          },
          {
            name: "arte",
            id: 3
          },
          {
            name: "construcciones",
            id: 4
          },
          {
            name: "noticias",
            id: 5
          }
        ],
        interestsExcludes: [{
            name: "musica",
            id: 1
          },
          {
            name: "futbol",
            id: 2
          },
          {
            name: "arte",
            id: 3
          },
          {
            name: "construcciones",
            id: 4
          },
          {
            name: "noticias",
            id: 5
          }
        ],
        userAccounts: [],
        userAccount: {},
        apps: [],
        app: {},
        lines: [],
        line: {},
        audiencias: [],
        audienciasInclude: [],
        audienciasExclude: [],
        isLoading: true,
        lifetime_budget: 0,
        campañaElejida: [],
        localizacionElejida: [],
        ratioElejido: []

      };
    },
    updated() {
      ////console.log("LOCALIZACION SELECCIONADA", this.localizacionElejida)

    },
    async mounted() {
      var minimi = document.getElementsByClassName(
        "header-fixed sidebar-fixed aside-menu-fixed aside-menu-off-canvas sidebar-lg-show"
      );
      if (minimi) {
        minimi = minimi[0];
        var button = document.getElementsByClassName(
          "d-md-down-none navbar-toggler"
        )[0];
        //button.click();
      }
      this.addAd();
      // var respuesta = await this.apiToken();
      var respuesta = await this.getCountries();
      respuesta = await this.getPartners();
      respuesta = await this.getapachePages();
      respuesta = await this.getSegmentationStrategy();
      respuesta = await this.getUserAccounts();
      respuesta = await this.getAllPixelsbyPartner();
      // this.getUserAccounts();
      respuesta = await this.getDevices();
      respuesta = await this.getpublisherPlatform();
      respuesta = await this.getadsetPosition();
      respuesta = await this.getuserDeviceOS();
      respuesta = await this.getcalltoAction();
      respuesta = await this.getLocalidad();



      // respuesta = await this.getSegmentationStrategy();

      // respuesta = await this.getBusinessAccounts();
      // respuesta = await this.getStrategyActions();
      // respuesta = await this.getCampaignObjetives();
      // respuesta = await this.getBillingEvents();
      // respuesta = await this.getOptimizationGoal();

      // respuesta = await this.getApps();
      // respuesta = await this.getLines();
      // respuesta = await this.getAudiencias();
      this.isLoading = false;
      //respuesta = await this.getBehaviors();
    },
    watch: {
      ads() {
        this.blockRemoval = this.ads.length <= 1;
      },
      partnerSelected: function (partnerSelected) {
        var partner_ids = [];
        //console.log("partner_ids::::", partnerSelected);
        if (partnerSelected !== null) {
          partner_ids.push(partnerSelected.id);
        }
        // partnerSelected.forEach((partner) => {
        //     partner_ids.push(partner.id);
        // });
        this.quizes = [];
        // this.pages = [];
        //console.log("partner_ids::::", partnerSelected, partner_ids);

        if (partner_ids.length > 0) {
          // partner_ids = partner_ids;
          this.partner_ids = partner_ids;
          this.getQuizesbyPartner();
          this.getlocationbyPartner();
          // this.getapachePages();
          // this.getAllPixelsbyPartner();
          // this.getSegmentationStrategy();
          // this.getUserAccounts();

        } else {
          this.quizes = [];
          // this.pages=[];
          this.surveys = [];
          // this.pixels=[];
          this.segmentationStrategies = [];
        }
      },

    },
    methods: {
      partnerLocationChange() {

       /* var newArray = []


        for (var x = 0; x <= this.localizacionElejida.length; x++) {
          if (this.localizacionElejida[x] > 1000 && this.localizacionElejida[x] < 1002) {
            this.locations[0].children.forEach((i) => {
              newArray.push(i.id)
            })
          } else if (this.localizacionElejida[x] > 1001 && this.localizacionElejida[x] < 1003) {
            this.locations[1].children.forEach((i) => {
              newArray.push(i.id)
            })
          } else if (this.localizacionElejida[x] > 1002 && this.localizacionElejida[x] < 1004) {
            this.locations[2].children.forEach((i) => {
              newArray.push(i.id)
            })
          } else if (this.localizacionElejida[x] > 1003 && this.localizacionElejida[x] < 1005) {
            this.locations[3].children.forEach((i) => {
              newArray.push(i.id)
            })
          } else if (this.localizacionElejida[x] > 1004 && this.localizacionElejida[x] < 1006) {
            this.locations[4].children.forEach((i) => {
              newArray.push(i.id)
            })
          } else {
            this.localizacionElejida = this.localizacionElejida
          }
        }
        this.localizacionElejida = newArray*/

        var newArray = []


        for (var x = 0; x < this.localizacionElejida.length; x++) {
         if(this.localizacionElejida[x] > 1000){
          for(var y = 0; y < this.locations.length; y++){
            if(this.localizacionElejida[x] == this.locations[y].id ){
              this.locations[this.localizacionElejida[x] - 1001].children.forEach((i)=>{
                newArray.push(i.id)
              })
            }
          }
         }else{
          newArray.push(this.localizacionElejida[x])
         }
          
          
        }
        this.localizacionElejida = newArray

      },
      getzonelist() {
        var countryobj1 = {}; //this.selectedCountry;
        countryobj1['children'] = null;
        countryobj1['label'] = this.selectedCountry.name;
        countryobj1['id'] = this.selectedCountry.id;
        countryobj1['code'] = this.selectedCountry.code;
        countryobj1['name'] = this.selectedCountry.name;

        var countryobj = [];
        countryobj.push(countryobj1);
        // //console.log("countryobj : ", countryobj1, countryobj);
        this.countriesIncludes = countryobj;

      },
      getAllData(segmentationStrategiesSelected) {

        //console.log("segmentationStrategiesSelected ::::: ", this.segmentationStrategies,   segmentationStrategiesSelected);
        this.segmentationStrategies.forEach(seg => {
          if (!seg.recommended_locations) {
            //console.log(seg);
          }
        })
        this.minAge = segmentationStrategiesSelected.age_min;
        this.maxAge = segmentationStrategiesSelected.age_max;
        // var genders=;
        // var genderSel = ""
        this.genders.map(genderobj => {
          if (genderobj.id == segmentationStrategiesSelected.gender) {
            this.genderSelected = genderobj;
          }
        });
        this.conectionTypes.map(device => {
          if (device.id == segmentationStrategiesSelected.wireless_carrier) {
            this.conectionTypeSelected = device;
          }
        });

        this.recommended_locations = segmentationStrategiesSelected.recommended_locations;

        var osids = [];
        //console.log(segmentationStrategiesSelected.os_ids, "segmentationStrategiesSelected.os_ids");
        segmentationStrategiesSelected.os_ids.map((os) => {
          var a = this.devicesOs.filter(obj => obj.id === os).map(obj => obj);
          osids.push(a[0]);
        });
        this.deviceOsSelected = osids;

        var publisher_platforms_ids = [];
        //console.log(segmentationStrategiesSelected.publisher_platforms_ids, this.publisherplatformsids,  "segmentationStrategiesSelected.publisher_platforms_ids");

        segmentationStrategiesSelected.publisher_platforms_ids.map((publisherplatformsids) => {
          var a = (this.publisherplatformsids.filter(obj => obj.id === publisherplatformsids).map(obj => obj));
          publisher_platforms_ids.push(a[0]);
        });
        this.publisher_platforms_ids = publisher_platforms_ids;

        var positionids = [];
        segmentationStrategiesSelected.position_ids.map((position) => {
          var a = (this.positionids.filter(obj => obj.id === position).map(obj => obj));
          positionids.push(a[0]);
        });
        this.position_ids = positionids;

        var device_types = [];
        segmentationStrategiesSelected.device_platforms_ids.map((device) => {
          var a = (this.deviceTypes.filter(obj => obj.id === device).map(obj => obj));
          device_types.push(a[0]);
        });
        this.deviceTypeSelected = device_types;

        // this.deviceOsSelected=segmentationStrategiesSelected.os_ids;
        // this.position_ids=segmentationStrategiesSelected.position_ids;
        // this.publisher_platforms_ids=segmentationStrategiesSelected.publisher_platforms_ids;
        // this.deviceTypeSelected=segmentationStrategiesSelected.device_platforms_ids;
        // this.genders.map(genderobj => {
        //   if (genderobj.id == segmentationStrategiesSelected.gender) {
        //     this.genderSelected= genderobj;
        //   }
        // });

        // var deviceOs = segmentationStrategiesSelected.os_ids;
        // var deviceOsChanged = [];
        // deviceOsChanged=deviceOs
        // //console.log("deviceOs=====", deviceOs);
        // this.devicesOs = deviceOsChanged;


        var deviceTypes = segmentationStrategiesSelected.device_platforms_ids;
        var deviceTypesChanged = [];
        deviceTypesChanged = deviceTypes;


        // this.deviceTypes = deviceTypesChanged;

        var wirelessCarrier = segmentationStrategiesSelected.wireless_carrier;
        // var deviceTypesChanged = [];
        // deviceTypesChanged=deviceTypes
        // this.deviceTypes = deviceTypesChanged;

      },
      addAd() {
        this.ads.push({
          titleAd: "", //third tab
          contentAd: "",
          descriptionAd: "",
          typeAdSelected: {},
          CallToActionSelected: {},
          files: [],
          url: ""
        });
      },
      removeAd(adId) {
        if (!this.blockRemoval) this.ads.splice(adId, 1);
      },
      showAd(adId) {
        this.titleAd = this.ads[adId].titleAd; //third tab
        this.contentAd = this.ads[adId].contentAd;
        this.descriptionAd = this.ads[adId].descriptionAd;
        // this.typeAdSelected = this.ads[adId].typeAdSelected;
        this.CallToActionSelected = this.ads[adId].CallToActionSelected;
        this.files = this.ads[adId].files;
      },
      adChange(adId) {
        this.titleAd = this.ads[adId].titleAd; //third tab
        this.contentAd = this.ads[adId].contentAd;
        this.descriptionAd = this.ads[adId].descriptionAd;
        // this.typeAdSelected = this.ads[adId].typeAdSelected;
        this.CallToActionSelected = this.ads[adId].CallToActionSelected;
        this.files = this.ads[adId].files;
      },
      async getuserDeviceOS() {
        var userDeviceOS = []; // store.getters.getDevices;
        this.isLoading = true;
        //console.log("1234 devices");
        await store.dispatch("getuserDeviceOS").then(() => {
          userDeviceOS = store.getters.getuserDeviceOS;
          if (userDeviceOS.length > 0) {
            this.devicesOs = userDeviceOS;
          } else {
            this.devicesOs = [];
          }
          return;
        });
      },
      async getDevices() {
        var devices = []; // store.getters.getDevices;
        this.isLoading = true;
        //console.log("1234 devices");
        await store.dispatch("getDevices").then(() => {
          devices = store.getters.getDevices;
          //console.log("devices :::: ", devices);
          if (devices.length > 0) {
            this.deviceTypes = devices;
          } else {
            this.deviceTypes = [];
          }
          return;
        });
      },
      async getpublisherPlatform() {
        var publisherPlatform = []; // store.getters.getDevices;
        this.isLoading = true;
        await store.dispatch("getpublisherPlatform").then(() => {
          publisherPlatform = store.getters.getpublisherPlatform;
          if (publisherPlatform.length > 0) {
            this.publisherplatformsids = publisherPlatform;
          } else {
            this.publisherplatformsids = [];
          }
          return;
        });
      },

      async getadsetPosition() {
        var adsetposition = []; // store.getters.getDevices;
        this.isLoading = true;
        await store.dispatch("getadsetPosition").then(() => {
          adsetposition = store.getters.getadsetPosition;
          if (adsetposition.length > 0) {
            this.positionids = adsetposition;
          } else {
            this.positionids = [];
          }
          return;
        });
      },
      async getDevices12() {
        var devices = store.getters.getDevices;
        if (devices.length == 0) {
          this.isLoading = true;
          await store.dispatch("getDevices").then(() => {
            devices = store.getters.getDevices;
            this.deviceTypes = devices;
            return;
          });
        } else {
          this.deviceTypes = devices;
          return;
        }
      },
      async getCampaignObjetives() {
        var campaignObjetives = store.getters.getCampaignObjetives;
        if (campaignObjetives.length == 0) {
          this.isLoading = true;
          await store.dispatch("getCampaignObjetives").then(() => {
            campaignObjetives = store.getters.getCampaignObjetives;
            this.campaignObjetives = campaignObjetives;
            return;
          });
        } else {
          this.campaignObjetives = campaignObjetives;
          return;
        }
      },
      async getBillingEvents() {
        var billingEvents = store.getters.getBillingEvents;
        if (billingEvents.length == 0) {
          this.isLoading = true;
          await store.dispatch("getBillingEvents").then(() => {
            billingEvents = store.getters.getBillingEvents;
            this.billingEvents = billingEvents;
            return;
          });
        } else {
          this.billingEvents = billingEvents;
          return;
        }
      },
      async getOptimizationGoal() {
        var optimizationGoals = store.getters.getOptimizationGoal;
        if (optimizationGoals.length == 0) {
          this.isLoading = true;
          await store.dispatch("getOptimizationGoal").then(() => {
            optimizationGoals = store.getters.getOptimizationGoal;
            this.optimizationGoals = optimizationGoals;
            return;
          });
        } else {
          this.optimizationGoals = optimizationGoals;
          return;
        }
      },
      async getStrategyActions() {
        var strategyActions = store.getters.getStrategyActions ?
          store.getters.getStrategyActions :
          [];
        //console.log("strategyActions:::::: ", strategyActions);
        if (strategyActions.length == 0) {
          this.isLoading = true;
          await store.dispatch("getStrategyActions").then(() => {
            strategyActions = store.getters.getStrategyActions;
            this.strategyActions = strategyActions;
            return;
          });
        } else {
          this.strategyActions = strategyActions;
          return;
        }
      },
      async getBehaviors() {
        var behaviors = store.getters.getBehaviors;
        if (behaviors.length == 0) {
          this.isLoading = true;
          await store.dispatch("getBehaviors").then(() => {
            behaviors = store.getters.getBehaviors;
            this.behaviors = behaviors;
            return;
          });
        } else {
          this.behaviors = behaviors;
          return;
        }
      },
      async getUserAccounts() {
        var userAccounts = []; //store.getters.getUserAccounts;
        this.isLoading = true;

        // var partner_ids = this.partnerSelected.id;
        // //console.log("this.partnerSelected :: ", this.partnerSelected, partner_ids);
        //,partner_ids
        await store.dispatch("getUserAccounts").then(() => {
          userAccounts = store.getters.getUserAccounts;
          //console.log("userAccounts", userAccounts);
          if (userAccounts.length > 0) {
            this.userAccounts = userAccounts;
          } else {
            this.userAccounts = [];
          }
          return;
        });

        // } else {
        //   this.userAccounts = userAccounts;
        //   return;
        // }
      },
      async getApps() {
        var apps = store.getters.getApps;
        if (apps.length == 0) {
          this.isLoading = true;
          await store.dispatch("getApps").then(() => {
            apps = store.getters.getApps;
            this.apps = apps;
            return;
          });
        } else {
          this.apps = apps;
          return;
        }
      },
      async getLines() {
        var lines = store.getters.getLines;
        if (lines.length == 0) {
          this.isLoading = true;
          await store.dispatch("getLines").then(() => {
            lines = store.getters.getLines;
            this.lines = lines;
            return;
          });
        } else {
          this.lines = lines;
          return;
        }
      },
      async getAudiencias() {
        var audiencias = store.getters.getAudiencias;
        if (audiencias.length == 0) {
          this.isLoading = true;
          await store.dispatch("getAudiencias").then(() => {
            audiencias = store.getters.getAudiencias;
            this.audiencias = audiencias;
            return;
          });
        } else {
          this.audiencias = audiencias;
          return;
        }
      },
      async interestsChange(searchQuery) {
        await store.dispatch("getInterests", searchQuery).then(() => {
          var interests = store.getters.getInterests;
          this.interests = interests;
          return;
        });
      },
      async loadOptions({
        action,
        parentNode,
        callback
      }) {
        //console.log("action, parentNode ::: ", action, parentNode);
        if (action === LOAD_CHILDREN_OPTIONS) {
          if (parentNode.hasOwnProperty("isState")) {
            await store.dispatch("getCityState", parentNode.id).then(() => {
              var result = store.getters.getCities;

              var regions = [];
              result.map(i => {
                var retorno = {
                  id: i.id,
                  label: i.name,
                  name: i.name,
                  country_id: i.country_id,
                  state_id: i.state_id,
                  isState: true
                };
                regions.push(retorno);

                return;
              });
              parentNode.children = regions;
              callback();
            });
          } else {
            await store.dispatch("getStateCountry", parentNode.id).then(() => {
              var result = store.getters.getStates;
              var regions = [];
              result.map(i => {
                var retorno = {
                  id: i.id,
                  code: i.code,
                  label: i.name,
                  name: i.name,
                  country_id: i.country_id,
                  children: null,
                  isState: true
                };
                regions.push(retorno);
                return;
              });
              parentNode.children = regions;
              callback();
            });
          }
        }
      },
      async apiToken() {
        var token = store.getters.getApiTokenFacebook;
        // if (token == "") {
        //   this.isLoading = true;
        //   await store.dispatch("getApiTokenFacebook").then(() => {
        //     return;
        //   });
        // } else {
        return;
        // }
      },
      async getLocalidad() {
        await store.dispatch("getLocalidad").then(() => {
          var localidadArray = []
          var localidad = store.getters.getLocalidad;
          //console.log("Esto es un test", localidad)
        })
      },
      async getCountries() {
        var countries = store.getters.getCountries;

        if (countries.length == 0) {
          this.isLoading = true;
          await store.dispatch("getCountries").then(() => {
            var countryArray = [];
            countries = store.getters.getCountries;
            //console.log("prueba de paises", countries)
            countries.map(i => {
              var retorno = {
                id: i.id,
                label: i.name,
                code: i.code,
                children: null
              };
              countryArray.push(retorno);
              return i;
            });
            this.countries = countries;
            return;
          });
        } else {
          var countryArray = [];
          countries = store.getters.getCountries;
          countries.map(i => {
            var retorno = {
              id: i.id,
              label: i.name,
              code: i.code,
              children: null
            };
            countryArray.push(retorno);
            return i;
          });
          this.countries = countries;
          return;
        }
      },
      async getPartners() {
        var partners = [];
        this.isLoading = true;
        await store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          if (partners.length > 0) {
            this.partners = partners;
            // this.partnerSelected = partners[0];
            //console.log(partners, ":::: partners ");
            // this.getQuizesbyPartner()
          } else {
            this.partners = [];
          }
          return;
        });

      },
      async getapachePages() {
        var pages = [];
        // this.isLoading = true;
        // var partner_ids = this.partnerSelected.id;
        // ,partner_ids

        await store.dispatch("getapachePages").then(() => {
          pages = store.getters.getapachePages;
          if (pages.length > 0) {
            this.pages = pages;
            //console.log(pages, ":::: pages ");
          } else {
            this.pages = [];
          }
          return;
        });

      },
      async getlocationbyPartner() {
        var locations = []
        var locationArray = []
        var cAArray = []
        var arrayFixed = []
        var contador = 1000
        var partner_ids = this.partnerSelected.id
        await store.dispatch("getlocationbyPartner", [partner_ids]).then(() => {
          locations = store.getters.getlocationbyPartner;

          if (locations.length > 0) {
            var locations_data = locations;




            locations_data.forEach((item) => {
              if (!(item.comunidad_autonoma in cAArray)) {
                cAArray.push(item.comunidad_autonoma)

              }

            });

            arrayFixed = cAArray.filter((v, i) => {
              return cAArray.indexOf(v) === i
            })


            arrayFixed.forEach((i) => {
              locationArray.push({
                label: i,
                children: [],
                id: contador = contador + 1
              })
            })

            locations_data.forEach((item) => {
              var retornado = {
                //children: [{label:1},{label:2}],
                id: item.id,
                label: item.locationName + " " + item.city,
              };
              locationArray.forEach((i) => {
                if (i.label == item.comunidad_autonoma) {
                  i.children.push(retornado)
                }
              })
            });



            this.locations = locationArray
            //console.log("locationdata", this.locations)

          } else {

            this.locations = []
          }
          return;
        });
      },
      async getQuizesbyPartner() {
        var quizes = []; //store.getters.getQuizesbyPartner;
        // this.isLoading = true;
        var partner_ids = this.partnerSelected.id;
        await store.dispatch("getQuizesbyPartner", partner_ids).then(() => {
          quizes = store.getters.getQuizesbyPartner;
          if (quizes.length > 0) {
            var quizes_data = quizes;
            quizes_data.forEach((item) => {
              item['qul_name'] = item.name + " - " + item.slug2;
            });
            this.quizes = quizes_data;
            //console.log("COSAS DE QUIZES", this.quizes)
          } else {
            this.quizes = [];
          }
          return;
        });
        // } else {
        //   this.partners = partners;
        //   return;
        // }
        // this.isLoading = false;

      },

      async getSegmentationStrategy() {
        var stereotypes = [];
        // var partner_ids = this.partnerSelected.id;
        //,partner_ids
        await store.dispatch("getStereotypesbyPartner").then(() => {
          stereotypes = store.getters.getStereotypesbyPartner;
          if (stereotypes.length > 0) {
            this.segmentationStrategies = stereotypes;
          } else {
            this.segmentationStrategies = [];
          }
          return;
        });
      },
      async getcalltoAction() {
        var calltoactions = [];
        await store.dispatch("getcalltoAction").then(() => {
          calltoactions = store.getters.getcalltoAction;
          if (calltoactions.length > 0) {
            this.CallToActions = calltoactions;
          } else {
            this.CallToActions = [];
          }
          return;
        });
      },
      async getSegmentationStrategy12() {
        var stereotypes = store.getters.getStereotypes;
        if (stereotypes.length == 0) {
          this.isLoading = true;
          await store.dispatch("getStereotypes").then(() => {
            stereotypes = store.getters.getStereotypes;
            //console.log("getStereotypes :::: ", store.getters.getStereotypes);
            this.segmentationStrategies = stereotypes;
            return;
          });
        } else {
          this.segmentationStrategies = stereotypes;
          return;
        }
      },
      async getBusinessAccounts() {
        var accounts = store.getters.getAdsAccounts;
        if (accounts.length == 0) {
          this.isLoading = true;
          await store.dispatch("getAdsAccounts").then(() => {
            accounts = store.getters.getAdsAccounts;
            this.accounts = accounts;
            return;
          });
        } else {
          this.accounts = accounts;
          return;
        }
      },
      async getPagePromotion(selectedOption) {
        this.promotionSelected = {};
        this.pageSelected = {};
        var pages = selectedOption.pages_ids;
        if (pages.length > 0) {
          this.pages = pages;
        }
        await store.dispatch("getPromotions").then(() => {
          var promotions = store.getters.getPromotions;
          var promotionsByPartner = [];
          promotions.map(promotion => {
            if (promotion.partner_id.id == selectedOption.id) {
              promotionsByPartner.push(promotion);
            }
          });
          this.promotions = promotionsByPartner;
          return;
        });
      },
      async getAllPixelsbyPartner() {
        // const id = selectedOption.id;
        // //console.log("store.getters.getAllPixels", store.getters.getAllPixels);
        // var partner_ids = this.partnerSelected.id;
        // , partner_ids
        var pixels = [];
        await store.dispatch("getAllPixelsbyPartner").then(() => {
          pixels = store.getters.getAllPixels;

          pixels.forEach((i) => {
            i["label"] = i.name + "-" + i.pixel_code


          })
          // var pixels_account = [];
          // pixels.map(pixel => {
          //   pixel.account_ids.map(acc => {
          //     if (acc.id == id) {
          //       pixels_account.push(pixel);
          //     }
          //   });
          // });
          //console.log("pixels :::: ", pixels);
          this.pixels = pixels;
          return;
        });
      },
      addTag(newTag) {
        const tag = {
          name: newTag,
          code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
        };
        this.options.push(tag);
        this.value.push(tag);
      },
      limitText(count) {
        return `and ${count} other countries`;
      },
      clearAll() {
        this.selectedCountry = [];
      },
      modalCreateF(nameModal) {
        this.modalName = nameModal;
        this.modalCreate = true;
      },
      closeModalCreate(reset) {
        if (reset == "partner") {
          this.partnerSelected = {};
        } else if (reset == "offert") {
          this.offertSelected = {};
        } else if (reset == "business") {
          this.accountSelected = {};
        }
        this.modalCreate = false;
      },
      onComplete: function () {
        //console.log("check 123");
        return new Promise((resolve, reject) => {
          if (
            this.genderSelected == null ||
            JSON.stringify(this.genderSelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar un genero";
            this.cookies = true;
            resolve(false);
          } else if (!this.recommended_locations) {

            if (
              this.deviceOsSelected == null ||
              JSON.stringify(this.deviceOsSelected) == "[]"
            ) {
              this.messageError = "Debe seleccionar un SO en dispositivos";
              this.cookies = true;
              resolve(false);
              //console.log("FALSE")
            } else if (
              this.deviceTypeSelected == null ||
              JSON.stringify(this.deviceTypeSelected) == "[]"
            ) {
              this.messageError = "Debe seleccionar un tipo de dispositivos";
              this.cookies = true;
              resolve(false);
              //console.log("FALSE")
            } else if (
              this.publisher_platforms_ids == null ||
              JSON.stringify(this.publisher_platforms_ids) == "[]"
            ) {
              this.messageError = "Debe seleccionar un plataformas para el annuncio";
              this.cookies = true;
              resolve(false);
              //console.log("FALSE")
            } else if (
              this.position_ids == null ||
              JSON.stringify(this.position_ids) == "[]"
            ) {
              this.messageError = "Debe seleccionar un posición";
              this.cookies = true;
              resolve(false);
              //console.log("FALSE")
            } else {
              
              resolve(true);
              //console.log("TRUE")
            }
          } else if (
            this.conectionTypeSelected == null ||
            JSON.stringify(this.conectionTypeSelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar un tipo de conexión";
            this.cookies = true;
            resolve(false);

          } else {
            this.push = true;
            resolve(true);
            this.crear();
          }
          
        });
      },
      validateFirstStep() {
        return new Promise((resolve, reject) => {
          if (
            this.partnerSelected == null ||
            JSON.stringify(this.partnerSelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar un partner";
            this.cookies = true;
            resolve(false);
          } else if (
            this.selectedCountry == null ||
            JSON.stringify(this.selectedCountry) == "{}"
          ) {
            this.messageError = "Debe seleccionar un pais";
            this.cookies = true;
            resolve(false);
          }/* else if (
            this.statusSelected == null ||
            JSON.stringify(this.statusSelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar un status";
            this.cookies = true;
            resolve(false);
          } */else if (this.adVisibleLink == "") {
            this.messageError = "Debe colocar un AD link visible";
            this.cookies = true;
            resolve(false);
          } else if (this.campaignName == "") {
            this.messageError = "Debe escribir un nombre de campaña";
            this.cookies = true;
            resolve(false);
          } /*else if (
            this.campaignObjetiveSelected == null ||
            JSON.stringify(this.campaignObjetiveSelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar un objetivo de campaña";
            this.cookies = true;
            resolve(false);
          } */else if (this.start_date == "") {
            this.messageError = "Debe seleccionar una fecha de inicio";
            this.cookies = true;
            resolve(false);
          } else if (this.end_date == "") {
            this.messageError = "Debe seleccionar una fecha de fin";
            this.cookies = true;
            resolve(false);
          } else {
            const campaign = {
              name: this.campaignName,
              // objetive: this.campaignObjetiveSelected.value,
              // status: this.statusSelected.value
            };
            // store.dispatch("getPixels").then(() => {
            //   this.isLoading = false;
            // });
            resolve(true);
          }
        });
      },
      /*validateSeconStep11() {
        return new Promise((resolve, reject) => {
          if (this.bidamounts == "") {
            this.messageError = "Debe colocar un coste por click";
            this.cookies = true;
            resolve(false);
          } else if (this.dailyBudget == "") {
            this.messageError = "Debe colocar presupuesto diario";
            this.cookies = true;
            resolve(false);
          } else if (this.dailyBudget < this.bidamounts) {
            this.messageError =
              "El coste por click no puede ser superior al presupuesto diarios";
            this.cookies = true;
            resolve(false);
          } else if (
            this.bidStrategySelected == null ||
            JSON.stringify(this.bidStrategySelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar una estrategía";
            this.cookies = true;
            resolve(false);
          } else if (
            this.billingEventSelected == null ||
            JSON.stringify(this.billingEventSelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar una facturación";
            this.cookies = true;
            resolve(false);
          } else if (
            this.optimizationGoalSelected == null ||
            JSON.stringify(this.optimizationGoalSelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar una optimización de logros";
            this.cookies = true;
            resolve(false);
          } else if (
            this.pacingTypeSelected == null ||
            JSON.stringify(this.pacingTypeSelected) == "{}"
          ) {
            this.messageError = "Debe seleccionar un ritmo";
            this.cookies = true;
            resolve(false);
          } else if (this.pacingTypeSelected == "") {
            this.messageError = "Debe seleccionar dar un monto de oferta";
            this.cookies = true;
            resolve(false);
          } else {
            resolve(true);
          }
        });
      },*/
      validateThirdStep() {
        var continua = true;
        this.ads.forEach(ad => {
          if (ad.titleAd == "") {
            this.messageError = "Debe colocar un título para el AD";
            this.cookies = true;
            continua = false;
          } else if (ad.contentAd == "") {
            this.messageError = "Debe colocar un contenido para el AD";
            this.cookies = true;
            continua = false;
          } else if (ad.descriptionAd == "") {
            this.messageError = "Debe colocar una descripción para el AD";
            this.cookies = true;
            continua = false;
          } else if (ad.files.length == 0) {
            this.messageError = "Debes subir un archivo para el AD";
            this.cookies = true;
            continua = false;
          }
          // else if (
          //   ad.typeAdSelected == null ||
          //   JSON.stringify(ad.typeAdSelected) == "{}"
          // ) {
          //   this.messageError = "Debe colocar un tipo de Add";
          //   this.cookies = true;
          //   continua = false;
          // } 
          else if (
            ad.CallToActionSelected == null ||
            JSON.stringify(ad.CallToActionSelected) == "{}"
          ) {
            this.messageError = "Debe colocar un call to action";
            this.cookies = true;
            continua = false;
          } else if (ad.url == null) {
            this.messageError = "Debes subir una imagen destacada";
            this.cookies = true;
            continua = false;
          } else {
            continua = true;
          }
        });
        return continua;
      },
      async previewFiles(adId) {
        const files = document.getElementById("files-" + adId).files;
        this.files = [];
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          var new_file = {
            type: "",
            url: "",
            file: "",
            file_64: ""
          };
          if (file.type.includes("video")) {
            new_file.type = "video";
          } else {
            new_file.type = "imagen";
          }
          var file_url = document.getElementById("files-" + adId).files[i];
          //console.log("file_url ::: ", file_url);
          var url = URL.createObjectURL(file_url);
          new_file.url = url;
          new_file.file = file_url;
          new_file.creative_filename = file_url.name;
          new_file.file_64 = await this.getBase64(file).then(data => {
            return data;
          });
          this.files.push(new_file);
        }
        this.ads[adId].files = this.files;
        this.titleAd = this.ads[adId].titleAd; //third tab
        this.contentAd = this.ads[adId].contentAd;
        this.descriptionAd = this.ads[adId].descriptionAd;
        this.typeAdSelected = this.ads[adId].typeAdSelected;
        this.CallToActionSelected = this.ads[adId].CallToActionSelected;
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },


      getAllParams() {
        //console.log("ENTRO POR AQUI")
        var {
          interestsIncludeSelected,
          interestsExcludeSelected,
          behaviorsExcludeSelected,
          behaviorsIncludeSelected,
          demographicIncludeSelected,
          demographicExcludeSelected
        } = this;

        var interests_includes = [];
        interestsIncludeSelected.map(interest => {
          interests_includes.push(interest.id);
        });

        var interests_excludes = [];
        interestsExcludeSelected.map(interest => {
          interests_excludes.push(interest.id);
        });

        var behaviors_includes = [];
        behaviorsIncludeSelected.map(behavior => {
          behaviors_includes.push(behavior.id);
        });

        var behaviors_excludes = [];
        behaviorsExcludeSelected.map(behavior => {
          behaviors_excludes.push(behavior.id);
        });

        // var audience_excludes = [];
        // audienciasExclude.map(behavior => {
        //   audience_excludes.push(behavior.id);
        // });

        // var audience_include = [];
        // audienciasInclude.map(behavior => {
        //   audience_include.push(behavior.id);
        // });
        var osids = [];
        this.deviceOsSelected.map(os => {
          //console.log("osselected", os);
          osids.push(os.id);
        });
        var deviceplatformsids = [];
        this.deviceTypeSelected.map(device => {
          //console.log("device selected", device);
          deviceplatformsids.push(device.id);
        });

        var publisherplatformsids = [];

        this.publisher_platforms_ids.map(platform => {
          //console.log("platform selected", platform);
          publisherplatformsids.push(platform.id);
        });

        var positionids = [];
        this.position_ids.map(position => {
          //console.log("position selected", position);
          positionids.push(position.id);
        });

        var demographic_includes = demographicIncludeSelected;
        var demographic_excludes = demographicExcludeSelected;
        var trueEndDate = this.end_date.replace(/([T])/g, " ")
        var trueStartDate = this.start_date.replace(/([T])/g, " ")
        var params = {
          living_location: this.lastLocationSelected.id,
          partner_id: this.partnerSelected.id,
          name: this.campaignName,
          start_date: trueStartDate.replace(/([Z])/g, ""),
          end_date: trueEndDate.replace(/([Z])/g, ""),
          lifetime_budget: this.lifetime_budget,
          page_id: this.pageSelected.id,
          pixel_id: this.pixelSelected.id,
          country_id: this.selectedCountry.id,
          user_account_id: this.userAccount.id,
          exclude_states_ids: this.demographicExcludeSelected,

          age_min: this.minAge,
          age_max: this.maxAge,
          gender: this.genderSelected.id,
          wireless_carrier: this.conectionTypeSelected.id,
          recommended_locations: this.recommended_locations,
          ratio: this.ratioElejido,
          location: this.localizacionElejida,
          type: this.campañaElejida.name,

          // os_ids: this.deviceOsSelected!==null? this.deviceOsSelected.id :"",
          // device_platforms_ids:this.deviceTypeSelected!==null?this.deviceTypeSelected:"",
          // publisher_platforms_ids:this.publisher_platforms_ids !== null ?this.publisher_platforms_ids.id :"",
          // position_ids:this.position_ids!==null? this.position_ids.id : "",

          os_ids: osids,
          device_platforms_ids: deviceplatformsids,
          publisher_platforms_ids: publisherplatformsids,
          position_ids: positionids,



          // pacing_type: this.pacingTypeSelected.value,
          // device_platforms_ids: this.deviceTypeSelected.id,
          // demographics_excludes: demographic_excludes,

          ads: this.orderAd()

          // promotion_id: this.promotionSelected.id,
          // account_id: this.accountSelected.id,
          // app_id: this.app.id,
          // content_line_id: this.line.id,
          // status: this.statusSelected.value,
          // allow_restart: this.allow_restart,

          // bid_strategy: this.bidStrategySelected.value,
          // objetive_id: this.campaignObjetiveSelected.code,
          // strategic_id: this.strategyActionSelected.id,
          // optimization_id: this.optimizationGoalSelected.code,
          // billing_event_id: this.billingEventSelected.code,
          // daily_budget: this.dailyBudget,
          // bid_amount: this.bidamounts,
          //split_by: this.split_by,
          // interests_includes: interests_includes,
          // interests_excludes: interests_excludes,
          // behaviors_includes: behaviors_includes,
          // behaviors_excludes: behaviors_excludes,
          // demographics_includes: demographic_includes,
          // audience_include,
          // audience_excludes,
          
        };

        return params;
        
      },
      orderAd() {
        var ads = [];
        this.ads.forEach(ad => {
          var params = {
            call_to_action_id: ad.CallToActionSelected.id,
            display_url: this.adVisibleLink,
            quiz_id: this.quizSelected.id,
            title_ids: {
              "name": "title",
              "text": ad.titleAd
            },
            body_ids: {
              "name": "body",
              "text": ad.contentAd
            },
            description_ids: {
              "name": "description",
              "text": ad.descriptionAd
            },
            files: ad.files,
            // type: ad.typeAdSelected.value,
            // title: ad.titleAd,
            // text: ad.contentAd,
            // description: ad.descriptionAd,
          };
          // //console.log(params , "::::: params");
          ads.push(params);
        });
        return ads;
      },
      async closedialog() {
        this.cookies = false;
      },
      async crear() {


        // //console.log("params =======>");
        var params = this.getAllParams();
        var segmentationSelected = this.segmentationStrategiesSelected;
        // var payload = {
        //   "params": params,
        //   "stereotype": this.segmentationStrategiesSelected;
        // }
        //console.log("======segmentationSelected before change=====", segmentationSelected);
        //console.log("params", params);
        segmentationSelected['gender'] = params.gender;
        segmentationSelected['recommended_locations'] = params.recommended_locations;
        segmentationSelected['age_max'] = params.age_max;
        segmentationSelected['age_min'] = params.age_min;

        segmentationSelected['os_ids'] = params.os_ids;
        segmentationSelected['conectionType'] = params.wireless_carrier;
        segmentationSelected['device_platforms_ids'] = params.device_platforms_ids;
        segmentationSelected['publisher_platforms_ids'] = params.publisher_platforms_ids;
        segmentationSelected['position_ids'] = params.position_ids;
        segmentationSelected['exclude_states_ids'] = params.exclude_states_ids;

        var seg_id = segmentationSelected.id;

        // var stereotype = {
        //     gender: this.genderSelected.id,
        //     conectionType: conectionTypeSelected.id,
        //     age_max: maxAge,
        //     age_min: minAge,
        //     recommended_locations: ubicacionRecomendada,
        //     name,
        //     // custom_audience_ids,
        //     // exclude_audience_ids,
        //     os_ids,
        //     device_platforms_ids,
        //     publisher_platforms_ids,
        //     position_ids,
        //     genderSelected,
        //     conectionTypeSelected,
        //     positon_selected,
        //     platform,
        //     device,
        //     os_selected,
        //     // audienciasSelectedExclude,
        //     // audienciasSelectedInclude,
        //     id,
        //   };



        //console.log("params =======>", params);
        await store.dispatch("newStepByStep", params).then(() => {
          //console.log("submited ok ");
          store.dispatch("editStereotype", segmentationSelected).then(() => {
            this.push = true;
            /*this.name = "";
            this.description = "";
            this.dateStart = "";
            this.dateEnd = "";
            this.linesSelected = [];*/

            // this.onClick();
            // this.cookies=true;
            // this.message="Estrategia de segmentación editada correctamente";
            // this.isLoading = false;
            // location.reload();
          });

          return;
        });
      },

      //  updateStereotype(stereotype) {
      //   // event.target.classList.add("was-validated");
      //   ;var stereotype = stereotype;
      //   this.isLoading = true;

      //     // var custom_audience_ids = [];
      //     // audienciasSelectedInclude.map((i) => {
      //     //   custom_audience_ids.push(i.id);
      //     // });
      //     // var exclude_audience_ids = [];
      //     // audienciasSelectedExclude.map((i) => {
      //     //   exclude_audience_ids.push(i.id);
      //     // });

      //     var os_ids = [];
      //     os_selected.map((i) => {
      //       os_ids.push(i.id);
      //     });

      //     var device_platforms_ids = [];
      //     device.map((i) => {
      //       device_platforms_ids.push(i.id);
      //     });

      //     var publisher_platforms_ids = [];
      //     platform.map((i) => {
      //       publisher_platforms_ids.push(i.id);
      //     });

      //     var position_ids = [];
      //     positon_selected.map((i) => {
      //       position_ids.push(i.id);
      //     });

      //     var stereotype = {
      //       gender: genderSelected.id,
      //       conectionType: conectionTypeSelected.id,
      //       age_max: maxAge,
      //       age_min: minAge,
      //       recommended_locations: ubicacionRecomendada,
      //       name,
      //       // custom_audience_ids,
      //       // exclude_audience_ids,
      //       os_ids,
      //       device_platforms_ids,
      //       publisher_platforms_ids,
      //       position_ids,
      //       genderSelected,
      //       conectionTypeSelected,
      //       positon_selected,
      //       platform,
      //       device,
      //       os_selected,
      //       // audienciasSelectedExclude,
      //       // audienciasSelectedInclude,
      //       id,
      //     };
      //     store.dispatch("editStereotype", stereotype).then(() => {
      //       /*this.name = "";
      //       this.description = "";
      //       this.dateStart = "";
      //       this.dateEnd = "";
      //       this.linesSelected = [];*/

      //       // this.onClick();
      //       this.cookies=true;
      //       this.message="Estrategia de segmentación editada correctamente";
      //       this.isLoading = false;
      //     });

      // },

      filterBehaviorsIncludeDelete(selectedOption) {
        const prueba = this.behaviorsExcludes;
        var indexIndentificate;
        prueba.map((behavior, index) => {
          if (behavior.id == selectedOption.id) {
            indexIndentificate = index;
          }
        });
        this.behaviorsExcludes.splice(indexIndentificate, 1);
      },
      filterBehaviorsIncludeAdd(selectedOption) {
        this.behaviorsExcludes.push(selectedOption);
      },
      filterBehaviorsExcludeDelete(selectedOption) {
        const prueba = this.behaviorsIncludes;
        var indexIndentificate;
        prueba.map((behavior, index) => {
          if (behavior.id == selectedOption.id) {
            indexIndentificate = index;
          }
        });
        this.behaviorsIncludes.splice(indexIndentificate, 1);
      },
      filterBehaviorsExcludeAdd(selectedOption) {
        this.behaviorsIncludes.push(selectedOption);
      },
      filterInterestsIncludeDelete(selectedOption) {
        const prueba = this.interestsExcludes;
        var indexIndentificate;
        prueba.map((interest, index) => {
          if (interest.id == selectedOption.id) {
            indexIndentificate = index;
          }
        });
        this.interestsExcludes.splice(indexIndentificate, 1);
      },
      filterInterestsIncludeAdd(selectedOption) {
        this.interestsExcludes.push(selectedOption);
      },
      filterInterestsExcludeDelete(selectedOption) {
        const prueba = this.interestsIncludes;
        var indexIndentificate;
        prueba.map((interest, index) => {
          if (interest.id == selectedOption.id) {
            indexIndentificate = index;
          }
        });
        this.interestsIncludes.splice(indexIndentificate, 1);
      },
      filterInterestsExcludeAdd(selectedOption) {
        this.interestsIncludes.push(selectedOption);
      },
      filterCountriesIncludeDelete(selectedOption) {
        const prueba = this.countriesExclude;
        var indexIndentificate;
        prueba.map((country, index) => {
          if (country.alpha3Code == selectedOption.alpha3Code) {
            indexIndentificate = index;
          }
        });
        this.countriesExclude.splice(indexIndentificate, 1);
      },
      filterCountriesIncludeAdd(selectedOption) {
        this.countriesExclude.push(selectedOption);
      },
      filterCountriesExcludeDelete(selectedOption) {
        const prueba = this.countriesIncludes;
        var indexIndentificate;
        prueba.map((country, index) => {
          if (country.alpha3Code == selectedOption.alpha3Code) {
            indexIndentificate = index;
          }
        });
        this.countriesIncludes.splice(indexIndentificate, 1);
      },
      filterCountriesExcludeAdd(selectedOption) {
        this.countriesIncludes.push(selectedOption);
      }
    }
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  .contenedor-preview {
    position: relative;
    height: 700px;
    background: rgb(32, 160, 255);
    border-radius: 2px;
  }

  .preview {
    position: relative;
    top: 45px;
    height: auto;
    background: #ffffff;
    color: #929292;
  }

  .imagen-perfil {
    position: relative;
    height: 50px;
    width: 50px;
    padding: none;
    margin: none;
    left: -40%;
  }

  .titulo-empresa h1 {
    font-size: 16px;
    color: #36508e;
    font-weight: 800;
    margin: 0;
    line-height: 110%;
  }

  .sponsor {
    color: grey;
    font-size: 12px;
  }

  .sponsor a {
    color: #ff5722;
  }

  .imagen-destacada {
    height: 226px;
  }

  #preview-img {
    /*position: relative;*/
    display: flex;
    text-align: center;
    justify-content: center;
    left: -5%;
  }

  #preview-img img {
    width: 110% !important;
  }

  .descripcion-contenedor {
    border-bottom: 1px solid #c5c5c5;
    border-right: 1px solid #c5c5c5;
    border-left: 1px solid #c5c5c5;
    padding: 10px;
    height: auto;
    margin-bottom: 70px;
    position: relative;
  }

  .addTitle {
    font-size: 19px;
    margin: 10px 0;
    line-height: 110%;
    font-weight: 400;
    color: rgb(76, 76, 76);
  }

  .link-anuncio {
    text-transform: uppercase;
    color: #929292;
    margin-top: 10px;
    font-size: 12px;
  }

  .call-to-action {
    font-size: 11px;
    background-color: #f8f8f8;
    color: #797979;
    border: 1px solid #797979;
    border-radius: 2px;
    padding: 4px 5px;
    transition: all 0.3s ease-in-out;
    height: 20px;
    line-height: 12px;
    position: relative;
    left: 12%;
  }

  #fecha-input {
    border: none !important;
    width: 100% !important;
    text-align: center !important;
    height: 30px !important;
    border-radius: 5px !important;
  }

  .interaccion {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .interaccion li {
    display: inline-block;
    color: #929292;
    margin-right: 20px;
    font-size: 15px;
  }

  .icono-error {
    font-size: 35px;
    color: #ff3547;
  }

  .icono-crear {
    color: rgb(32, 160, 255);
    cursor: pointer;
    font-size: 16px;
    padding-left: 5px;
  }

  .boton-pregunta {
    background: transparent !important;
    border: none;
    box-shadow: none;
    padding: 0px;
  }

  .modal-body {
    overflow-y: auto;
    height: 400px;
  }

  #checkbox-1 {
    height: 20px;
    position: absolute;
  }

  .checkbox-2 {
    height: 20px;
    position: absolute;
  }

  .carrousel-test {
    height: 400px;
  }

  .video-component {
    height: 350px;
  }

  .contener-completo {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }

  .VueCarousel-navigation-prev {
    padding-right: 5%;
  }

  .VueCarousel-navigation-next {
    padding-left: 5% !important;
  }

  .VueCarousel-navigation-button.VueCarousel-navigation-prev {
    padding-right: 5% !important;
  }

  .VueCarousel,
  .VueCarousel .VueCarousel-inner {
    height: 100% !important;
  }

  .contener-completo .VueCarousel-inner {
    height: 100% !important;
  }

  .multiselect__tag {
    background: #fff !important;
  }
</style>